/* GENERATED by scripts/gen-visualizer-registry.cjs - do not edit by hand. */
/* Regenerate with: npm run generate:visualizers */
import type { VisualizerType } from "../../../platform/visualizers/visualizerLoader";

const visualizerModules = {
  ["../visualizers/abstractart.visualizer.tsx"]: () =>
    import("./abstractart.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/architecturalblueprint.visualizer.tsx"]: () =>
    import("./architecturalblueprint.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/bargraph.visualizer.tsx"]: () =>
    import("./bargraph.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/biologicalcell.visualizer.tsx"]: () =>
    import("./biologicalcell.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/circuitboard.visualizer.tsx"]: () =>
    import("./circuitboard.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/circularspectrogram.visualizer.tsx"]: () =>
    import("./circularspectrogram.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/circularwave.visualizer.tsx"]: () =>
    import("./circularwave.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/cityscape.visualizer.tsx"]: () =>
    import("./cityscape.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/constellation.visualizer.tsx"]: () =>
    import("./constellation.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/cosmicpulse.visualizer.tsx"]: () =>
    import("./cosmicpulse.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/crystal.visualizer.tsx"]: () =>
    import("./crystal.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/crystalv2.visualizer.tsx"]: () =>
    import("./crystalv2.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/dna.visualizer.tsx"]: () =>
    import("./dna.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/dnav2.visualizer.tsx"]: () =>
    import("./dnav2.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/firespectrum.visualizer.tsx"]: () =>
    import("./firespectrum.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/flower.visualizer.tsx"]: () =>
    import("./flower.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fluid.visualizer.tsx"]: () =>
    import("./fluid.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fluidwave.visualizer.tsx"]: () =>
    import("./fluidwave.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fractal.visualizer.tsx"]: () =>
    import("./fractal.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fracture.visualizer.tsx"]: () =>
    import("./fracture.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fracturedcircle.visualizer.tsx"]: () =>
    import("./fracturedcircle.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/fracturedprism.visualizer.tsx"]: () =>
    import("./fracturedprism.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/frequencyflower.visualizer.tsx"]: () =>
    import("./frequencyflower.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/frequencymesh.visualizer.tsx"]: () =>
    import("./frequencymesh.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/frequencystars.visualizer.tsx"]: () =>
    import("./frequencystars.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/galaxy.visualizer.tsx"]: () =>
    import("./galaxy.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/galaxyv2.visualizer.tsx"]: () =>
    import("./galaxyv2.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/geometricpulse.visualizer.tsx"]: () =>
    import("./geometricpulse.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/interference.visualizer.tsx"]: () =>
    import("./interference.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/kaleidoscope.visualizer.tsx"]: () =>
    import("./kaleidoscope.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/kaleidoscopespectrogram.visualizer.tsx"]: () =>
    import("./kaleidoscopespectrogram.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/layeredripplevoronoi.visualizer.tsx"]: () =>
    import("./layeredripplevoronoi.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/liquidmetal.visualizer.tsx"]: () =>
    import("./liquidmetal.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/matrixrain.visualizer.tsx"]: () =>
    import("./matrixrain.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/nebula.visualizer.tsx"]: () =>
    import("./nebula.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/neonwave.visualizer.tsx"]: () =>
    import("./neonwave.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/neural.visualizer.tsx"]: () =>
    import("./neural.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/neurospectogram.visualizer.tsx"]: () =>
    import("./neurospectogram.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/oceanwaves.visualizer.tsx"]: () =>
    import("./oceanwaves.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/organic.visualizer.tsx"]: () =>
    import("./organic.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/oscilloscope.visualizer.tsx"]: () =>
    import("./oscilloscope.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/particlefield.visualizer.tsx"]: () =>
    import("./particlefield.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/pixeldust.visualizer.tsx"]: () =>
    import("./pixeldust.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/pulsingorbs.visualizer.tsx"]: () =>
    import("./pulsingorbs.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/quantum.visualizer.tsx"]: () =>
    import("./quantum.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/rainbowspiral.visualizer.tsx"]: () =>
    import("./rainbowspiral.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/ribbondance.visualizer.tsx"]: () =>
    import("./ribbondance.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/sacredgeometry.visualizer.tsx"]: () =>
    import("./sacredgeometry.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/spectrumripple.visualizer.tsx"]: () =>
    import("./spectrumripple.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/spiralspectogram.visualizer.tsx"]: () =>
    import("./spiralspectogram.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/spiralv2.visualizer.tsx"]: () =>
    import("./spiralv2.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/starfield.visualizer.tsx"]: () =>
    import("./starfield.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/tesselation.visualizer.tsx"]: () =>
    import("./tesselation.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/topwater.visualizer.tsx"]: () =>
    import("./topwater.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/voltaicarcs.visualizer.tsx"]: () =>
    import("./voltaicarcs.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/voronoi.visualizer.tsx"]: () =>
    import("./voronoi.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/vortex.visualizer.tsx"]: () =>
    import("./vortex.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/water.visualizer.tsx"]: () =>
    import("./water.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/waterfall.visualizer.tsx"]: () =>
    import("./waterfall.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/waveformrings.visualizer.tsx"]: () =>
    import("./waveformrings.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/waveformspectrum.visualizer.tsx"]: () =>
    import("./waveformspectrum.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/waveformtunnel.visualizer.tsx"]: () =>
    import("./waveformtunnel.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/waveinterference.visualizer.tsx"]: () =>
    import("./waveinterference.visualizer").then((m) => m.default as VisualizerType),
  ["../visualizers/weather.visualizer.tsx"]: () =>
    import("./weather.visualizer").then((m) => m.default as VisualizerType),
} as Record<string, () => Promise<VisualizerType>>;

const visualizerDisplayNames: Record<string, string> = {
  "abstractart": "Abstract Art",
  "architecturalblueprint": "Architectural Blueprint",
  "bargraph": "Bar Graph",
  "biologicalcell": "Biological Cell",
  "circuitboard": "Circuit Board",
  "circularspectrogram": "Circular Spectrogram",
  "circularwave": "Circular Wave",
  "cityscape": "Dynamic Cityscape",
  "constellation": "Constellation Spectrogram",
  "cosmicpulse": "Cosmic Pulse",
  "crystal": "Crystal Formation",
  "crystalv2": "Crystalline Formation",
  "dna": "DNA Helix Spectrogram",
  "dnav2": "DNA Helix",
  "firespectrum": "Fire Spectrum",
  "flower": "Flower Spectrogram",
  "fluid": "Fluid Dynamics",
  "fluidwave": "Fluid Wave",
  "fractal": "Fractal Tree",
  "fracture": "Fracture Spectrogram",
  "fracturedcircle": "Fractured Circle",
  "fracturedprism": "Fractured Prism",
  "frequencyflower": "Frequency Flower",
  "frequencymesh": "Frequency Mesh",
  "frequencystars": "Frequency Stars",
  "galaxy": "Galaxy Formation",
  "galaxyv2": "Galaxy Spectrogram v2",
  "geometricpulse": "Geometric Pulse",
  "interference": "Wave Interference Spectrogram",
  "kaleidoscope": "Kaleidoscope",
  "kaleidoscopespectrogram": "Kaleidoscope Spectrogram",
  "layeredripplevoronoi": "Layered Ripple Voronoi",
  "liquidmetal": "Liquid Metal",
  "matrixrain": "Matrix Rain",
  "nebula": "Cosmic Nebula",
  "neonwave": "Neon Wave",
  "neural": "Neural Network Visualization",
  "neurospectogram": "Neural Network Spectrogram",
  "oceanwaves": "Ocean Waves",
  "organic": "Organic Growth Spectrogram",
  "oscilloscope": "Oscilloscope",
  "particlefield": "Particle Field",
  "pixeldust": "Pixel Dust",
  "pulsingorbs": "Pulsing Orbs",
  "quantum": "Quantum Field",
  "rainbowspiral": "Rainbow Spiral",
  "ribbondance": "Ribbon Dance",
  "sacredgeometry": "Sacred Geometry",
  "spectrumripple": "Spectrum Ripple",
  "spiralspectogram": "Spiral Spectrogram",
  "spiralv2": "Spiral Spectrogram v2",
  "starfield": "Star Field",
  "tesselation": "Tessellation Spectrogram",
  "topwater": "Top-Down Water Spectrogram",
  "voltaicarcs": "Voltaic Arcs",
  "voronoi": "Voronoi Spectrum",
  "vortex": "Vortex Spectrogram",
  "water": "3D Water Spectrogram",
  "waterfall": "Waterfall",
  "waveformrings": "Waveform Rings",
  "waveformspectrum": "Waveform Spectrum",
  "waveformtunnel": "Waveform Tunnel",
  "waveinterference": "Wave Interference Spectrogram",
  "weather": "Weather Pattern Spectrogram",
};

export function visualizerModuleLoaders(): Record<string, () => Promise<VisualizerType>> {
  return visualizerModules;
}

export function visualizerModuleNames(): string[] {
  return Object.keys(visualizerModules);
}

export function visualizerDisplayName(key: string): string | undefined {
  return visualizerDisplayNames[key];
}
